(()=>{
  function init(){
    const main=document.getElementById('MainContent');if(!main)return;
    main.querySelectorAll('[data-zs-generated-next]').forEach(el=>el.remove());
    const panels=[...main.querySelectorAll('[data-zs-panel]')].filter(el=>!el.hidden&&!el.closest('[hidden]'));
    main.querySelectorAll('[data-zs-first-panel]').forEach(el=>el.removeAttribute('data-zs-first-panel'));
    if(panels[0])panels[0].setAttribute('data-zs-first-panel','');
    panels.forEach((panel,i)=>{if(!panel.id)panel.id="zs-chapter-"+i+"-"+Math.random().toString(36).slice(2,8);});
    panels.forEach((panel,i)=>{
      const target=panels[i+1]||panels[0],last=i===panels.length-1;
      const a=document.createElement('a');a.href='#'+target.id;a.className='zs-chapter-next'+(last?' zs-chapter-next--start':'');a.dataset.zsGeneratedNext='';
      a.append(document.createTextNode(last?'Start':'Weiter'));a.setAttribute('aria-label',last?'Zurück zum Anfang dieser Seite':'Weiter zum nächsten Abschnitt');
      const tpl=document.getElementById(last?'zs-arrow-up':'zs-arrow-down');if(tpl)a.append(tpl.content.cloneNode(true));
      panel.append(a);
    });
  }
  document.addEventListener('click',event=>{
    const a=event.target.closest('[data-zs-generated-next]');if(!a||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const target=document.getElementById(a.hash.slice(1));if(!target)return;event.preventDefault();
    if(!target.hasAttribute('tabindex'))target.tabIndex=-1;target.focus({preventScroll:true});
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);document.addEventListener('shopify:section:unload',()=>setTimeout(init,0));document.addEventListener('shopify:section:reorder',init);
})();
